import { useFeatureGoogleAnalytics } from '../../../../shared_app/hooks/useFeatureGoogleAnalytics';
var SKILLS_REPORT_EVENT_CATEGORY = 'SkillsReport';
var SkillsReportEvents = {
    pageView: SKILLS_REPORT_EVENT_CATEGORY + "_Open",
    diagramsArrowClick: SKILLS_REPORT_EVENT_CATEGORY + "_DiagramsArrow_Click",
    diagramsHelpHover: SKILLS_REPORT_EVENT_CATEGORY + "_DiagramsTooltip_Hover",
    diagramsBarHover: SKILLS_REPORT_EVENT_CATEGORY + "_Bars_Hover",
    diagramsPieChartHover: SKILLS_REPORT_EVENT_CATEGORY + "_PieCharts_Hover",
    diagramsPieChartTbdHover: SKILLS_REPORT_EVENT_CATEGORY + "_BarsGrey_Hover",
    diagramsPieChartHelpNeededHover: SKILLS_REPORT_EVENT_CATEGORY + "_BarsRed_Hover",
    diagramsPieChartDevelopingHover: SKILLS_REPORT_EVENT_CATEGORY + "_BarsYellow_Hover",
    diagramsPieChartMasteredHover: SKILLS_REPORT_EVENT_CATEGORY + "_BarsGreen_Hover",
    diagramsTooltipHover: SKILLS_REPORT_EVENT_CATEGORY + "_BarsTooltip_Hover",
    diagramsHelpNeededStudentClick: SKILLS_REPORT_EVENT_CATEGORY + "_Bars_StudentNameHelpNeeded_Click",
    diagramsDevelopingStudentClick: SKILLS_REPORT_EVENT_CATEGORY + "_Bars_StudentNameDeveloping_Click",
    diagramsMasteredStudentClick: SKILLS_REPORT_EVENT_CATEGORY + "_Bars_Mastered_Click",
    diagramsTBDStudentClick: SKILLS_REPORT_EVENT_CATEGORY + "_Bars_TBD_Click",
    diagramsDomainClick: SKILLS_REPORT_EVENT_CATEGORY + "_BarsDomain_Click ",
    diagramsGradeClick: SKILLS_REPORT_EVENT_CATEGORY + "_BarsGrade_Click",
    struggleFilterEnable: SKILLS_REPORT_EVENT_CATEGORY + "_FilterStuggle",
    dropdownDomainSelect: SKILLS_REPORT_EVENT_CATEGORY + "_DomainDropDown_Select",
    tableLegendHover: SKILLS_REPORT_EVENT_CATEGORY + "_Legend_Hover",
    tableArrowClick: SKILLS_REPORT_EVENT_CATEGORY + "_SkillsArrow_Click",
    tableSortBySkillClick: SKILLS_REPORT_EVENT_CATEGORY + "_SortBySkill_Click",
    studentNameClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentName_Click",
    studentRowClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentSkillsLine_Click",
    studentSkillCellClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentSkillCell_Click",
    studentReportLinkClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentReport_Open",
    studentRowExpand: SKILLS_REPORT_EVENT_CATEGORY + "_StudentArrow_Click",
    struggleStudentRowExpand: SKILLS_REPORT_EVENT_CATEGORY + "_StruggleStudentArrow_Click",
    studentDetailsHelpNeededTabClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_TabHelpNeeded_Select",
    studentDetailsDevelopingTabClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_TabDeveloping_Select",
    studentDetailsMasteredTabClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_TabMastered_Select",
    studentDetailsSummaryTabClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_TabSummary_Select",
    studentDetailsSkillSelect: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_Skill_Select",
    studentDetailsCardClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_OpenCard",
    studentDetailsTimeSpentHover: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_CardTimeSpent_Hover",
    studentDetailsHigherLevelSkillClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_HigherLevelSkill_Click",
    studentDetailsLoadMoreSkillsClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_LoadMoreSkills_Click",
    studentDetailsLoadMoreCardsClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_LoadMoreTasks_Click",
    studentDetailsScrollToTopClick: SKILLS_REPORT_EVENT_CATEGORY + "_StudentMenu_Scroll",
};
var useSkillsReportAnalytics = function () {
    return useFeatureGoogleAnalytics(SKILLS_REPORT_EVENT_CATEGORY);
};
export { useSkillsReportAnalytics, SkillsReportEvents };
